<template>
    <div class="tree-box">
        <div class="tree-wraper">
            <el-tree
                v-if="!loading"
                ref="tree"
                lazy
                :data="list"
                :load="load"
                :highlight-current="true"
                @node-expand="docheck"
                @node-collapse="docheck"
                :empty-text="$t('Loading')"
                :check-on-click-node="true"
                :render-content="renderContent"
                @node-click="docheck"
                node-key="id">
            </el-tree>
        <loading v-if="loading" />
        </div>
    </div>
</template>

<script>
import Loading from '@/components/Loading'
import {getTeams} from '@/store/service/team'
import { mapActions,mapState} from 'vuex';
export default {
    data(){
        return {
           loading: true,
           list: []
        }
    },
    components:{
        Loading
    },
    created(){
        setTimeout(async () => {
            let {status,data} = await new Promise(async (resolve) => {
                getTeams({offset: 0,count: 100},(res) => {
                    resolve(res)
                })
            })
            let list = [{
                name: this.$t('Mycloud'),
                id: this.group,
                user_role: "group"
            }]
            this.list = status == 200 ? list.concat(data.groups) : list
            this.loading = false
        }, 300);
    },
    mounted(){
        let data = {
            name: this.$t('Mycloud'),
            id: this.group,
            user_role: "group"
        }
        this.$emit('checked',data)
    },
    computed:{
        ...mapState([
            'group'
        ])
    },
    methods:{
        renderContent(h,{node,data,store}){
             return (
                <div class="tree-item">
                    <i class={`${node.loading ? '':'components-icons components-icons-folder-s-selected'}`}><span class="path1"></span></i>
                    <span class="tree-name nowrap" title={data.fname || data.name}>{data.fname || data.name}</span>
                </div>
            )
        },
        async load(node,resolve){

            let {data,level} = node
            
            if (level === 0) {
                resolve(this.list)
            }else{
                let result
                let groupid = data.groupid || data.id
                let parentid = data.fname ? data.id : 0
                try {
                    result = await this.$axios.get(`/api/v3/groups/${groupid}/files?offset=0&count=100&orderby=mtime&order=DESC&filter=folder&groupid=${groupid}&parentid=${parentid}`)
                } catch (error) {
                    resolve([])
                    this.$message.error(this.$t('errInter'))
                    return
                }
                resolve(result.data.files)
            }
           
        },
        docheck(data,node){
            this.$refs.tree.setCurrentKey(data.id)
            this.$emit('checked',node.data)
        },
        onConfirm(){

        }
    }
}
</script>

<style>
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
    background: #fafcff;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/file/Tree.vue